<div class="tooltip" [class.tooltip--hero]="variant === 'hero'">
  <ng-content></ng-content>
  <svg
    class="tooltip__pointer"
    [ngClass]="'tooltip__pointer--' + direction"
    width="24"
    height="7"
    viewBox="0 0 24 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      [attr.fill]="variant === 'hero' ? '#FAF7F0' : '#011835'"
      d="M9.17158 1.82842L6.34315 4.65685C4.84286 6.15714 2.80802 7 0.686292 7H23.3137C21.192 7 19.1571 6.15715 17.6569 4.65686L14.8284 1.82843C13.2663 0.26633 10.7337 0.266328 9.17158 1.82842Z"
    />
  </svg>
</div>
